import type { CSSProperties, ReactNode } from "react";

import {
  OPERATOR_WORKSPACE_FRAME_CLASS_NAME,
  OPERATOR_WORKSPACE_PANE_CLASS_NAME,
} from "./operator/operatorWorkspaceLayout";
import { OperatorWorkspaceSurface } from "./operator/OperatorWorkspaceSurface";
import { getWorkspaceAppearance } from "./operator/workspaceAppearance";
import { cn } from "~/lib/utils";

export function StandaloneSurfaceShell({
  children,
  contentClassName,
}: {
  readonly children: ReactNode;
  readonly contentClassName?: string;
}) {
  return (
    <div
      className={OPERATOR_WORKSPACE_FRAME_CLASS_NAME}
      style={
        { "--workspace-background": getWorkspaceAppearance(undefined).gradient } as CSSProperties
      }
    >
      <main className={OPERATOR_WORKSPACE_PANE_CLASS_NAME}>
        <OperatorWorkspaceSurface className="items-center justify-center px-4 py-10 text-foreground sm:px-6">
          <div aria-hidden="true" className="drag-region absolute inset-x-0 top-0 h-12" />
          <div className={cn("w-full max-w-[240px]", contentClassName)}>{children}</div>
        </OperatorWorkspaceSurface>
      </main>
    </div>
  );
}
